export const DEFAULT_FILE_TYPE = "default";
export const COS_FILE_TYPE = "cos";
export const IELTS_FILE_TYPE = "ielts";
export const PTE_FILE_TYPE = "pte";
export const MONTHLY_UPLOAD_FILE_TYPE = "monthly_upload";

// DefaultFileType       FileTypeV2 = "default"
// COSFileType           FileTypeV2 = "cos"
// IELTSFileType         FileTypeV2 = "ielts"
// PTEFileType           FileTypeV2 = "pte"
// MonthlyUploadFIleType FileTypeV2 = "monthly_upload"

export const OUTDATED_FILE_STATUS = "outdated";
export const NOT_RELEVANT_FILE_STATUS = "not_relevant";
